import { axios } from './config';

export function postGiftPaymentLink({ price, message, relationship, locale, occasion }) {
  return axios.post('/stripe/payment-link/gift/', { price, message, relationship, locale, occasion });
}
